module.exports = __webpack_public_path__ + "./assets/loopnet_logo.png";